import type {
  SheetParameterValues,
  HomePlanParameterValues,
  BuilderParameterValues,
  CommunityParameterValues,
  LotSpecificParameterValues,
  MasterPlanParameterValues,
  ViewportParameterValues,
  RoomParameterValues,
} from "building-types/systemParameterTypes";
import type { GarageHandingDirection } from "./garageHanding";

interface HomePlanParameterValuesWithoutShowroomURL extends Omit<HomePlanParameterValues, "homePlanShowroomURL"> {}
interface SystemParameterHomeAttributes
  extends Partial<
    SheetParameterValues &
      MasterPlanParameterValues &
      HomePlanParameterValuesWithoutShowroomURL &
      BuilderParameterValues &
      CommunityParameterValues &
      LotSpecificParameterValues &
      ViewportParameterValues &
      RoomParameterValues
  > {}

export interface HomeAttributes extends SystemParameterHomeAttributes {
  /**
   * Specifies the native garage-handing direction of the building. When set, this
   * will override the behavior associated w/ garage-handing set at the lot-level.
   * TODO: Migrate this out of the home attributes table and into its own property on the doc.
   */
  readonly garageHandingDirection: GarageHandingDirection;
}

export const SystemParameterHomeAttributesKeys: Record<keyof SystemParameterHomeAttributes, true> = {
  currentSheetNumber: true,
  currentSheetNumberPrefix: true,
  currentSheetName: true,
  masterPlanName: true,
  homePlanName: true,
  homePlanSetId: true,
  homePlanStatus: true,
  homePlanPriceBase: true,
  homePlanPriceOptions: true,
  homePlanPriceDiscount: true,
  homePlanPriceTotal: true,
  homePlanLotPremium: true,
  builderName: true,
  builderAddress: true,
  builderCity: true,
  builderState: true,
  builderZip: true,
  currentLocationName: true,
  companyName: true,
  regionName: true,
  divisionName: true,
  communityName: true,
  phaseName: true,
  multiunitName: true,
  communityGeneralNotes: true,
  communityGovernmentCodeAndStandards: true,
  communityBuildingCodeAnalysisDesignCriteria: true,
  communityPlanName: true,
  customerName: true,
  lotNumber: true,
  lotAddress: true,
  viewportName: true,
  viewportDescription: true,
  viewportNumber: true,
  viewportScale: true,
  roomArea: true,
  roomCeilingHeight: true,
  roomDimensions: true,
  roomFloorMaterial: true,
  roomReportedName: true,
  roomTagDetails: true,
  roomType: true,
  roomBathroomCount: true,
  roomBedroomCount: true,
  roomGarageCount: true,
} as const;
